import {UPDATE_USER_INFO, APISERVICE_INITIALIZED, LANGUAGE_CHANGED, HIDE_SCORE_CHANGED} from '../constants';

export const setUserStatus = (user) => (dispatch, getState) => {
	dispatch({type: UPDATE_USER_INFO, user});
};

export const setInitialized = (isInitialized) => (dispatch, getState) => {
	dispatch({type: APISERVICE_INITIALIZED, isInitialized});
};

export const setLocaleLanguage = (locale) => (dispatch, getState) => {
	dispatch({type: LANGUAGE_CHANGED, locale});
};

export const setHideScore = (hideScore) => (dispatch, getState) => {
	dispatch({type: HIDE_SCORE_CHANGED, hideScore});
};
